var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Auth',[_c('AuthForm',{on:{"authenticate":_vm.authenticate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }